import InterfaceSKDP from "../apiInterface/InterfaceSKDP";
import { join, values, mapValues } from "lodash";
import ErrorAlert from "@/utility/ErrorAlert";

class DataSKDP {
  async getDataSKDP(reg) {
    // let dt: object = {}
    let dt: any;
    await InterfaceSKDP.getSKDP(reg)
      .then(response => {
        dt = response.data;
        // console.log(dt)
      })
      .catch(e => {
        // dt = e.response
        // console.log(e);
        dt = e.response
        ErrorAlert.showSnackAlert(e, "SKDP")
      });
    return dt;
  }
  async getDataSKDPByID(id) {
    // let dt: object = {}
    let dt: any;
    await InterfaceSKDP.getSKDPByID(id)
      .then(response => {
        dt = response.data;
        // console.log(dt)
      })
      .catch(e => {
        // dt = e.response
        // console.log(e);
        dt = e.response
        ErrorAlert.showSnackAlert(e, "SKDP Detail")
      });
    return dt;
  }

  async saveDataTtdSKDP(id, user_id, password) {
    let dt: object = {};
    await InterfaceSKDP.saveTtdSKDP(id, user_id, password)
      .then(response => {
        dt = response.data;
        // console.log(dt)
      })
      .catch(e => {
        dt = e.response;
        // ErrorAlert.showErrorAlert(e)
        // if (dt['status'] == 422) {
        //   dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        // } else {
        //   dt = { data: dt, status: dt['status'], err: "ERR " + e.response.status + " : " + e.response.data.message }
        // }
      });
    // console.log(dt);
    return dt;
  }

  async saveDataSKDP(
    reg,
    dpjp_id,
    unit_id,
    tgl_rujukan,
    diagnosis,
    alasan,
    rtl,
    tgl_kunjungan,
    user_id,
    kronis
  ) {
    let dt: object = {};
    await InterfaceSKDP.saveSKDP(
      reg,
      dpjp_id,
      unit_id,
      tgl_rujukan,
      diagnosis,
      alasan,
      rtl,
      tgl_kunjungan,
      user_id,
      kronis
    )
      .then(response => {
        dt = response.data;
        console.log(dt);
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
        // let message = "";
        // if (dt['status'] == 422) {
        //   message = join(
        //     values(
        //       mapValues(e.response.data.errors, function (val) {
        //         return join(val, "; ");
        //       })
        //     ),
        //     "; "
        //   );
        //   dt = { status: 0, err: "ERR 422 : " + e.response.data.message + " (" + message + ")" }
        //   // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        // } else {
        //   dt = { data: dt, status: dt['status'], err: "ERR " + e.response.status + " : " + e.response.data.message }
        // }
      });
    return dt;
  }

  async changeDataSKDP(
    id,
    reg,
    dpjp_id,
    unit_id,
    tgl_rujukan,
    diagnosis,
    alasan,
    rtl,
    tgl_kunjungan,
    user_id,
    kronis
  ) {
    let dt: object = {};
    await InterfaceSKDP.changeSKDP(
      id,
      reg,
      dpjp_id,
      unit_id,
      tgl_rujukan,
      diagnosis,
      alasan,
      rtl,
      tgl_kunjungan,
      user_id,
      kronis
    )
      .then(response => {
        dt = response.data;
        console.log(dt);
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
        // let message = "";
        // if (dt['status'] == 422) {
        //   message = join(
        //     values(
        //       mapValues(e.response.data.errors, function (val) {
        //         return join(val, "; ");
        //       })
        //     ),
        //     "; "
        //   );
        //   dt = { status: 0, err: "ERR 422 : " + e.response.data.message + " (" + message + ")" }
        //   // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        // } else {
        //   dt = { data: dt, status: dt['status'], err: "ERR " + e.response.status + " : " + e.response.data.message }
        // }
      });
    return dt;
  }

  async getDataAlasan(term) {
    let dt = [];
    await InterfaceSKDP.getAlasan(term)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        // console.log(e);
      });
    return dt;
  }

  async getDataRtl(term) {
    let dt = [];
    await InterfaceSKDP.getRtl(term)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        console.log(e);
      });
    return dt;
  }

  async getDataKontrolSkdpAlert(tgl, unit_id, dr_id) {
    let dt = [];
    const param = { tgl: tgl, unit_id: unit_id, dr_id: dr_id };

    await InterfaceSKDP.getKontrolSkdpAlert(param).then(response => {
      dt = response.data;
    });

    return dt;
  }

  async getKuotaMjknRange(unit_id, dr_id, from, to) {
    let dt = [];
    const param = { unit_id: unit_id, dr_id: dr_id, from: from, to: to };

    await InterfaceSKDP.getKuotaMjkn(param)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        console.log(e);
      });

    return dt;
  }
}

export default new DataSKDP();
